























































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class SkeletonLoader extends Vue {
  @Prop() readonly width!: number;
  @Prop() readonly height!: number;
  @Prop() readonly svgHeight!: number;
}
